import script from "./FeaturedProject.vue?vue&type=script&setup=true&lang=js"
export * from "./FeaturedProject.vue?vue&type=script&setup=true&lang=js"

import "./FeaturedProject.vue?vue&type=style&index=0&id=553b5b87&lang=css"

const __exports__ = script;

export default __exports__